import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function AddImageDialog ({
  open,
  images,
  removeImage,
  handleClose,
  uploadImage,
  handleChange,
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle>{"Add Image"}</DialogTitle>
        <form style={{ width: "400px" }} onSubmit={e => uploadImage(e, "add")}>
          <DialogContent style={{ paddingBottom: 0, paddingTop: 0 }}>
            <DialogContentText id='alert-dialog-slide-description'>
              <div style={styles.container}>
                {/* Upload Box */}
                {images?.length == 0 && (
                  <label style={styles.uploadBox}>
                    <input
                      name='image'
                      type='file'
                      required
                      // accept='.jpg, .jpeg, .png, .gif, .bmp, .tiff, .tif, .webp, .heif, .heic, .ico, .svg, .eps, .ai, .raw, .cr2, .nef, .arw, .psd, .exr, .dds'
                      accept='image/*'
                      // value={handleChange?.image}
                      onChange={handleChange}
                      style={{ display: "none" }}
                    />
                    <div style={styles.uploadContent}>
                      <CloudUploadOutlinedIcon fontSize='60px' sx={{ fontSize: "60px" }} />
                      <p>Drop files here or click to upload</p>
                    </div>
                  </label>
                )}

                {/* Image Previews */}
                {images?.length > 0 && (
                  <div style={styles.previewContainer}>
                    {images?.map((image, index) => (
                      <div key={index} style={styles.imageWrapper}>
                        <img src={image} alt={`preview-${index}`} style={styles.image} />
                        <button onClick={() => removeImage(index)} style={styles.removeBtn}>
                          ✖
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type='submit'>Submit</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "90%",
    minWidth: "100%",
    margin: "auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    margin: "auto",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
